<template>
  <div>
    <v-card 
      class='mx-2' 
      outlined
    >
      <v-container>
        <v-row justify="center">
          <h4> Cardholder Import </h4>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            PlaceId at which Cardholders will be created.  Must be Customer level or below.
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              v-model="placeId"
              outlined
              placeholder="e.g. 0DH5Ec200Kr"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-textarea
            v-model="cardholderCsvs"
            outlined
            label="Cardholders"
            placeholder="Paste CSVs here.  No headers.  Each line should be: Firstname, Lastname, Card Value, Job Title, Department, GroupId (Optional)"
            rows="20"
          ></v-textarea>
        </v-row>
        <v-row>
          <v-btn
            color="primary darken-1" 
            @click="importCardholders"
          >
            Import
          </v-btn>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "CardImport",
  props: {
    app: Object,
    setProgressVal: Function,
    setProgressLinear: Function,
  },
  data: () => ({
    placeId: "",
    cardholderCsvs: ""
  }),
  methods: {
    async importCardholders() {      
      this.setProgressVal(0);
      this.setProgressLinear(true);
      const rows = this.cardholderCsvs.split("\n");
      let idx = 0;
      for (const row of rows) {
        const vals = row.split(",");
        if (vals.length < 5 || vals.length > 6) {
          alert("Bad value count at row " + idx + ": " + row);
          break;
        }
        let groupId = "";
        if (vals.length == 6) {
          groupId = vals[5];
        }
        await this.postCardholder(this.placeId, vals[0], vals[1], vals[2], vals[3], vals[4], groupId);
        idx++;
        this.setProgressVal(100*idx/rows.length);
      }
      this.setProgressLinear(false);
      alert(`Finished import of ${idx} cardholders`);
    },

    async postCardholder(placeId, firstname, lastname, cardValue, title, department, groupId) {
      let url = '/API/public/support/cardholder/new';
      const now = new Date();
      const body = {
        placeId: placeId,
        email: "",
        firstName: firstname,
        lastName: lastname,
        title: title,
        department: department,
        value: cardValue,
        validTo: "2050-12-31",
        validFrom: `${now.getFullYear()}-${now.getMonth()+1}-${now.getDate()}`,
        enabled: true
      };
      await this.app.restApi({
          method: 'post',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          },
          data: body,
        })
        .then(async response => {
          const personId = response.data?.personID;
          if (!!groupId && !!personId) {
            url = `/API/public/support/cardholder/${personId}?groupId=${groupId}`;
            await this.app.restApi({
                method: 'post',
                url: url,
                headers: {
                  'Authorization': 'Bearer ' + this.app.userProfile.token
                },
              })
              .catch(error => {
                console.log("AddPersonGroup error", error);
                let msg = "Failed to add cardholder " + personId + " to group " + groupId + ".";
                msg += "Check Portal API log files for error details. (" + error.response.status + ")"
                alert(msg)
              })
          }
        })
        .catch(error => {
          console.log("Create cardholder error", error);
          let msg = "Failed to create cardholder " + firstname + " " + lastname + ".";
          msg += "Check Portal API log files for error details. (" + error.response.status + ")"
          alert(msg)
        });
    },
  }
}
</script>